import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutlineSharp';

import { AppContext } from './AppState';
import ConfirmModal from './ConfirmModal';


const useStyles = makeStyles((theme) => ({
  icon: {
    marginTop: theme.spacing(-0.5),
  },
}));

export default function DeleteModal(props) {
  const { material, visible, setVisible, onDelete } = props;

  const classes = useStyles();
  const { showAlert } = useContext(AppContext);

  async function handleConfirmDelete(confirm) {
    if (confirm) {
      const res = await onDelete(material.materialId);
      if (res) {
        showAlert({ status: 'success', message: 'Material deleted' });
      } else {
        showAlert({ status: 'error', message: 'An error occurred while deleting the material' });
      }
    }
    setVisible(false);
  }

  return (
    <>
      {material && (
        <ConfirmModal
          visible={visible}
          title={<><DeleteOutlineIcon className={classes.icon}/> Delete material</>}
          message={<>Are you sure you want to delete this material: <b>{material.name}?</b></>}
          onYes={() => handleConfirmDelete(true)}
          onNo={() => handleConfirmDelete(false)}
          confirmText='Delete'
        />
      )}
    </>
  );
}
